export default "__VITE_ASSET__C9cmRa$t__"